import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import withStyles from 'react-jss';
import { Translation } from 'react-i18next';
import { getPreRegistrationState, getTenantState } from '../../store/selectors';
import { addCampus, getCampusDataForTenant } from '../../store/actions';
import ProgressBar from '../utility/ProgressBar';
import LoginButton from '../utility/LoginButton';
import NextButton from '../utility/NextButton';
import PoweredByASUBlackAndWhite from '../utility/PoweredByASUBlackAndWhite';
import RouteBack from '../utility/RouteBack';
import SchoolLogo from '../utility/SchoolLogo';
import WindowTitle from '../utility/WindowTitle';

const bars = {
  Onboarding: {
    current: 0,
    override: true,
  },
  'Picture Game': {
    current: 0,
    override: false,
  },
  'Career Path': {
    current: 0,
    override: false,
  },
};

const nextButtonStyles = {
  color: (props) => ({
    backgroundColor: props.color,
    borderColor: props.color,

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.color}`,
      color: props.color,
      borderStyle: 'solid',
    },
  }),
};

class CampusSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCampus: null,
      percent: 70,
      campusOptions: [],
      loading: false,
      // error: null,
    };
    this.handleCampusSelected = this.handleCampusSelected.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fetchCampusData = this.fetchCampusData.bind(this);
  }

  dropDown = {
    color: this.props.tenant.primary,
  };

  secondaryBorderLarge = {
    borderTop: `11px solid ${this.props.tenant.secondary}`,
  };

  secondaryBorder = {
    borderBottom: `5px solid ${this.props.tenant.secondary}`,
  };

  componentDidMount() {
    this.fetchCampusData();
  }

  async fetchCampusData() {
    const { tenant, preregistration } = this.props;
    if (!tenant || !tenant.id) {
      return;
    }

    try {
      // set loading state
      this.setState({ loading: true });

      // Fetch campus data from the API
      const campusDataFromAPI = await this.props.getCampusDataForTenant(
        tenant.id
      );

      // MOCK API RESPONSE - In a real app, this would be a fetch() call
      const formattedOptions = campusDataFromAPI.map((campus) => ({
        id: campus.id,
        value: campus.name,
        label: campus.name,
      }));

      if (preregistration && preregistration.campusId) {
        const restoredOption = formattedOptions.find(
          (option) => option.id === preregistration.campusId
        );

        if (restoredOption) {
          this.setState({ selectedCampus: restoredOption });
        }
      }

      this.setState({ campusOptions: formattedOptions, loading: false });
    } catch (e) {
      console.error('Failed to fetch campus data:', e);
      this.setState({ loading: false });
    }
  }

  CustomInput = (props) => (
    /* eslint-disable react/jsx-props-no-spreading */
    <components.Input
      {...props}
      role="combobox"
      aria-controls={`${props.id}-combobox-menu-list`}
      aria-expanded={props.selectProps.menuIsOpen}
      aria-activedescendant=""
    />
  );

  CustomMenuList = (props) => (
    <components.MenuList {...props}>
      <div
        role="listbox"
        id={`${props.selectProps.inputId}-combobox-menu-list`}
      >
        {props.children}
      </div>
    </components.MenuList>
  );

  CustomOption = (props) => (
    <components.Option {...props}>
      <div
        role="option"
        aria-selected={props.selectProps.value === props.children}
      >
        {props.children}
      </div>
    </components.Option>
  );

  handleCampusSelected(selectedCampus) {
    this.setState({
      selectedCampus: selectedCampus,
    });
    // Add campus to the redux store
    this.props.addCampus(selectedCampus.id);
  }

  handleSubmit() {
    if (!this.state.selectedCampus) return;
    // Add in redux store
    this.handleCampusSelected(this.state.selectedCampus);
    // Example: customize these routes as actual onboarding flow
    this.props.history.push(
      `/${this.props.tenant.name.toLowerCase()}/terms-and-conditions`
    );
  }

  render() {
    const { selectedCampus } = this.state;
    const { primary } = this.props.tenant;

    const customStyles = {
      option: (provided) => ({
        ...provided,
        color: primary,
      }),
      input: (provided) => ({
        ...provided,
        color: primary,
      }),
      placeholder: (provided) => ({
        ...provided,
        color: primary,
      }),
      singleValue: (provided) => ({
        ...provided,
        color: primary,
        overflow: 'visible',
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: primary,
      }),
    };

    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>
              {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
              {t('Onboarding')} - {t('Campus')}
            </WindowTitle>
            <div
              id="location-page"
              style={{ borderTop: `11px solid ${this.props.tenant.secondary}` }}
            >
              <div className="top-section">
                <div className="utility-container">
                  <RouteBack
                    color={this.props.tenant.primary}
                    route="/onboarding/location"
                    tenant={this.props.tenant}
                    section="Select your campus"
                    text="back"
                  />
                  <LoginButton
                    tenant={this.props.tenant}
                    color={this.props.tenant.primary}
                    isAuthenticated={this.props.auth.isAuthenticated}
                    section="Select your campus"
                  />
                </div>
                <div className="logo-text-container">
                  <SchoolLogo
                    schoolLogoWidth="90%"
                    horizontalAlign="flex-start"
                  />
                  <div className="header-text-container">
                    <h1>
                      Which campus are you currently attending or most
                      interested in attending?
                    </h1>
                    <div
                      className="fake-border"
                      style={{
                        borderBottom: `5px solid ${this.props.tenant.secondary}`,
                      }}
                    />
                  </div>
                  <div className="column is-one-quarter asu-logo-container-game-dummy" />
                </div>
              </div>
              <div className="columns is-centered is-multiline middle-section">
                <div className="dropdowns-container">
                  <Select
                    components={{
                      Input: this.CustomInput,
                      MenuList: this.CustomMenuList,
                      Option: this.CustomOption,
                    }}
                    onChange={this.handleCampusSelected}
                    options={this.state.campusOptions}
                    value={this.state.selectedCampus}
                    className="campus-dropdown-select"
                    inputId="country-select"
                    styles={customStyles}
                    placeholder={selectedCampus || 'Select a campus'}
                    aria-label="type your campus"
                    isLoading={this.state.loading}
                  />
                </div>
                <NextButton
                  key={this.props.location.pathname}
                  overRideStyle="location-next-button"
                  color={this.props.tenant.primary}
                  id="submit"
                  type="submit"
                  text="Next"
                  isActive={Boolean(this.state.selectedCampus)}
                  onClick={() => this.handleSubmit()}
                  nextPath={`/${this.props.tenant.name.toLowerCase()}/terms-and-conditions`}
                />
              </div>
              <div className="bottom-section">
                <ProgressBar
                  bars={bars}
                  currentPhase={this.state.percent}
                  tenant={this.props.tenant}
                />
              </div>
              <PoweredByASUBlackAndWhite tenant={this.props.tenant} />
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);
  const preregistration = getPreRegistrationState(state);
  const auth = state.auth;
  return { tenant, preregistration, auth };
};

const campusWithRouter = withRouter(
  connect(mapStateToProps, { addCampus, getCampusDataForTenant })(
    CampusSelector
  )
);

export default withStyles(nextButtonStyles)(campusWithRouter);
